import React from "react"
import { c } from "ttag"
import { BaseProps, Tooltip } from "@humanpredictiveintelligence/myqvt-library"
import { Badge } from "@material-ui/core"

import { SurveyStatus } from "features/Shared"
import { CustomSurveyStatus, Survey, Theme } from "models/Survey"
import * as SurveyInfoStyles from "features/Shared/styles/SurveyInfo.styles"
import Moment from "moment/moment"

export const CustomSurveyInfo: React.FC<CustomSurveyInfoProps> = (props) => {
  const themeIcon = (
    <SurveyInfoStyles.ThemeIcon
      icon={props.surveyTheme?.icon}
      name={!props.isMini ? props.surveyTheme?.name : undefined}
      color={props.surveyTheme?.color}
      size={props.isMini ? "small" : "medium"}
    />
  )

  const surveyStatus = props.survey.nextUsedAt || props.survey.lastUsedAt
    ? CustomSurveyStatus.Used
    : CustomSurveyStatus.Valid

  const usageWording = getUsageWording(props.survey, props.isMini)

  return (
    <SurveyInfoStyles.Container $isCompact $isMini={props.isMini} className={props.className}>
      <SurveyInfoStyles.ThemeContainer>
        {props.isMini && (
          <Badge
            classes={{ badge: "StatusContainer" }}
            anchorOrigin={{
              horizontal: "right",
              vertical: "top",
            }}
            badgeContent={<SurveyStatus isCompact status={surveyStatus}/>}
            showZero
          >
            {themeIcon}
          </Badge>
        )}
        {!props.isMini && themeIcon}
      </SurveyInfoStyles.ThemeContainer>
      <SurveyInfoStyles.Content
        $isCompact={!props.isMini}
        $isScrollbarVisible={props.isScrollbarVisible}
      >
        <div>
          {!props.isMini && (
            <Tooltip title={props.survey?.name} enterDelay={1500}>
              <SurveyInfoStyles.Title>
                {props.survey?.name}
              </SurveyInfoStyles.Title>
            </Tooltip>
          )}

          <SurveyInfoStyles.ActivePeriod>
            {usageWording}
          </SurveyInfoStyles.ActivePeriod>

        </div>

        {!props.isMini && <SurveyStatus status={surveyStatus}/>}
      </SurveyInfoStyles.Content>
    </SurveyInfoStyles.Container>
  )

  function getUsageWording(survey: Survey, isMini?: boolean): string {
    const dateFormat = isMini ? "L" : "L LT"

    if (survey.lastUsedAt) {
      const lastUsedAt = Moment(survey.lastUsedAt).format(dateFormat)
      return c("Survey usage wording").t`Last used at: ${lastUsedAt}`
    }

    if (survey.nextUsedAt) {
      const nextUsedAt = Moment(survey.nextUsedAt).format(dateFormat)
      return c("Survey usage wording").t`Will be used at: ${nextUsedAt}`
    }

    return c("Survey usage wording").t`Never used`
  }
}

interface CustomSurveyInfoProps extends BaseProps {
  /** Theme reference for this scheduled survey */
  surveyTheme: Theme,

  /** Survey reference for this scheduled survey */
  survey: Survey,

  /** If true reduce the component size and wordings as much as possible */
  isMini?: boolean,

  isScrollbarVisible?: boolean,
}
